import GenericModel from '../generic-model';

export default class RequestedProductSize extends GenericModel {
  width?: number;
  height?: number;

  constructor() {
    super();
  }
}
